import React from 'react';

export type Props = {
    pathProps?: React.SVGProps<SVGPathElement>;
    isEmpty?: boolean;
};

export const MarkerIcon = ({pathProps, isEmpty}: Props) => {
    if (isEmpty) {
        return <EmptySmallMarkerIcon pathProps={pathProps} />;
    } else {
        return <SmallMarkerIcon pathProps={pathProps} />;
    }
};

const SmallMarkerIcon = ({pathProps}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="29"
            height="31"
            viewBox="0 0 29 31"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.502187 14.25C0.500731 14.3332 0.5 14.4165 0.5 14.5C0.5 18.4761 2.15756 21.9325 4.81938 24.3521C6.56137 26.0019 8.73346 27.2108 11.1525 27.7979C14.0905 28.7219 14.0307 31 14.5 31C14.9687 31 14.9195 28.7133 17.8674 27.7931C20.2785 27.2042 22.4434 25.9973 24.1806 24.3521C26.8424 21.9325 28.5 18.4761 28.5 14.5C28.5 14.4165 28.4993 14.3332 28.4978 14.25C28.4993 14.1668 28.5 14.0835 28.5 14C28.5 6.26801 22.232 0 14.5 0C6.76801 0 0.5 6.26801 0.5 14C0.5 14.0835 0.500731 14.1668 0.502187 14.25Z"
                fill="none"
                {...pathProps}
            />
        </svg>
    );
};

const EmptySmallMarkerIcon = ({pathProps}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="29"
            height="32"
            viewBox="0 0 29 32"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.502187 14.75C0.500731 14.8332 0.5 14.9165 0.5 15C0.5 18.9761 2.15756 22.4325 4.81938 24.8521C6.56137 26.5019 8.73346 27.7108 11.1525 28.2979C14.0905 29.2219 14.0307 31.5 14.5 31.5C14.9687 31.5 14.9195 29.2133 17.8674 28.2931C20.2785 27.7042 22.4434 26.4973 24.1806 24.8521C26.8424 22.4325 28.5 18.9761 28.5 15C28.5 14.9165 28.4993 14.8332 28.4978 14.75C28.4993 14.6668 28.5 14.5835 28.5 14.5C28.5 6.76801 22.232 0.5 14.5 0.5C6.76801 0.5 0.5 6.76801 0.5 14.5C0.5 14.5835 0.500731 14.6668 0.502187 14.75Z"
                fill="none"
                {...pathProps}
            />
            <circle cx="14.5" cy="14.5" r="11" fill="white" />
        </svg>
    );
};
